<template>
  <div id="newuser-main">
    <v-container fluid ma-0 pa-0 px-4>
      <div class="fixed-header" :class="{'mobile': $vuetify.breakpoint.smAndDown}"><!-- if has summary fields add class 'with-summary' -->
        <v-layout  align-center fill-height class="fixed-header-wrapper">
          <v-flex shrink class="text-truncate" pr-4>
            <v-tooltip color="secondary" bottom>
              <template v-slot:activator="{ on }">
                <h2 v-on="on" class="p-relative text-truncate" >
                  {{ inviteSent ? 'Invitation sent' : 'New User' }}
                </h2>
              </template>
                <span>Users</span>
              </v-tooltip>
            <h4 class="pt-1 sub-header ">Users - <span class="font-weight-bold">{{total}}</span></h4>
          </v-flex>
          <v-spacer></v-spacer>
          <v-divider vertical ></v-divider>
          <v-flex shrink fill-height class="action">
            <v-tooltip left color="secondary">
              <v-btn
                icon
                flat
                slot="activator"
                @click="goToUsers"
              >
              <v-icon color="success" size="24">add_circle</v-icon>
                </v-btn>
                <span>Create a new User</span>
              </v-tooltip>
          </v-flex>
        </v-layout>
      </div>
      <v-layout row wrap fluid class="card-margin-fix">
        <v-flex>
          <div v-if="inviteSent" class="newuser-invite-success mx-2 mt-4">
            <h3 class="mb-2">Invitation sent</h3>
            <p class="mb-2">
              An email has been sent to <strong>{{ invitedEmail }}</strong> with a one-time link to set their password.
            </p>
            <p class="mb-4 grey--text text--darken-1">
              They should receive it shortly. The link is valid for one hour.
            </p>
            <p v-if="successDetail" class="caption mb-4">{{ successDetail }}</p>
            <v-btn class="newuser-back-to-users-btn ml-0" color="success" @click="goToUsers">Back to Users</v-btn>
            <v-btn class="newuser-invite-another-btn ml-2" color="secondary" outline @click="resetForm">Invite another user</v-btn>
          </div>
          <template v-else>
            <v-layout mb-2 mx-2 mt-4>
              <v-flex>
                <label>E-mail</label>
                <v-text-field
                  class="newuser-email-text"
                  label="Email"
                  v-model="user.email"
                  placeholder="e.g. jill@acme.com"
                  :disabled="submitting"
                  solo flat>
                </v-text-field>
                <label>Display Name</label>
                <v-text-field
                  class="newuser-name-text"
                  label="Display Name"
                  v-model="user.displayName"
                  placeholder="e.g. jill B"
                  :disabled="submitting"
                  solo flat>
                </v-text-field>
                <p class="caption grey--text text--darken-1 mb-2">
                  The user will receive an email with a one-time link to set their password.
                </p>
                <v-alert
                  v-if="errorMessage"
                  :value="true"
                  type="error"
                  class="newuser-error-alert mb-2"
                >
                  {{ errorMessage }}
                </v-alert>
              </v-flex>
            </v-layout>
            <v-flex xs6 style="float:right;">
              <v-btn class="newuser-cancel-btn" color="error" :disabled="submitting" @click="cancelCreate">Cancel</v-btn>
              <v-btn
                class="newuser-invite-btn"
                color="success"
                :loading="submitting"
                :disabled="submitting"
                @click="createUser"
              >Invite User</v-btn>
            </v-flex>
          </template>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapState } from 'vuex'

export default {
  data () {
    return {
      user: { email: "", displayName: "" },
      submitting: false,
      inviteSent: false,
      invitedEmail: "",
      successDetail: "",
      errorMessage: null
    }
  },
  computed: {
    ...mapState({
      users: state => state.users.all
    }),
    total() {
      if (this.users && this.users.length > 0) {
        return this.users.length
      } else {
        return 0
      }
    }
  },
  methods: {
    async createUser() {
      this.errorMessage = null
      this.submitting = true
      try {
        const result = await this.$store.dispatch("createUser", this.user)
        if (!result || result.error) {
          this.errorMessage = (result && result.message) || "Could not invite user."
          return
        }
        this.invitedEmail = this.user.email
        this.successDetail = result.message || ""
        this.inviteSent = true
      } catch (err) {
        this.errorMessage = (err && err.message) || "Could not invite user."
      } finally {
        this.submitting = false
      }
    },
    resetForm() {
      this.user.email = ""
      this.user.displayName = ""
      this.inviteSent = false
      this.invitedEmail = ""
      this.successDetail = ""
      this.errorMessage = null
    },
    goToUsers() {
      Vue.router.push({ name: "Users" })
    },
    cancelCreate() {
      this.resetForm()
      this.goToUsers()
    }
  }
}
</script>
